import { IPreloadedState } from 'shared/types/redux';

export const selectSelectedDistricts = (state: IPreloadedState) => state.geo.districtsSwitcher.selectedDistricts;
